<template>
	<div>
		<modal-confirmacao
			:exibir="exibir"
			:mensagem="mensagemModalExclusao"
			:subtituloModal="subtituloModalExclusao"
			:tituloModal="tituloModalexclusao"
			@confirmar="excluir"
			@fechar-modal="$emit('fechar-modal')"
		></modal-confirmacao>
	</div>
</template>
<script>
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'
import { actionTypes, mutationTypes, routesNames } from '@/core/constants'
import validacaoAta from '@/views/mixins/validacaoAta'

export default {
	name: 'modal-excluir-ata',
	components: { ModalConfirmacao },
	mixins: [validacaoAta],
	props: {
		exibir: Boolean,
		informacoesAta: {
			type: Object,
			required: true,
			default: () => {
				return {
					isBloqueado: false,
				}
			},
		},
	},
	data() {
		return {
			mensagemModalExclusao: 'A ata excluída não poderá ser recuperada!',
			subtituloModalExclusao: 'Deseja realmente excluir?',
			tituloModalexclusao: 'Excluir',
		}
	},
	methods: {
		async excluir() {
			await this.$store.dispatch(actionTypes.ATA.EXCLUIR, { idAta: this.informacoesAta.id })
			this.resetarStates()
			await this.redirecionarParaListagem()
			this.mostrarNotificacaoSucessoDefault()
		},
		async redirecionarParaListagem() {
			await this.$router.push({ name: routesNames.ATA.ATA_VIEW })
		},
		resetarStates() {
			this.resetarStoreAta()
			this.resetarStoreItemAta()
		},
		resetarStoreAta() {
			this.$store.commit(mutationTypes.ATA.RESET_INFORMACOES_ATA)
			this.$store.commit(mutationTypes.ATA.LIMPAR_FILTRO_LISTAGEM)
			this.$store.commit(mutationTypes.ATA.RESETAR_PAGINA_LISTAGEM)
		},
		resetarStoreItemAta() {
			this.$store.commit(mutationTypes.ITEM_ATA.RESETAR_PAGINA_LISTAGEM)
			this.$store.commit(mutationTypes.ITEM_ATA.LIMPAR_ITENS_PARA_ADICIONAR)
			this.$store.commit(mutationTypes.ITEM_ATA.RESET_ITENS_ATA_SELECIONADOS)
		},
	},
}
</script>
<style lang="stylus" scoped></style>
